module.exports = __webpack_public_path__ + "static/media/buy-me-a-coffee.498d99a5.svg";